import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
import { useRoute, useLazyAsyncData } from '#app'

// Define props with types using a single call to defineProps

export default /*#__PURE__*/_defineComponent({
  __name: 'PagePart',
  props: {
  partKey: {
    type: String,
    required: true,
  },
  wrapperTag: {
    type: String,
    default: 'div', // Default to 'div' if no tag is provided
  },
},
  setup(__props) {

const { partKey, wrapperTag } = __props;



// No need to define localeCode as a prop since we'll compute it based on the route or a provided value
const route = useRoute()

// Compute localeCode based on the route params or a provided value
const localeCode = computed(() => (route.params.lang as string) || 'en-gb')

// Use useLazyAsyncData to lazily fetch and set the page part HTML content
const { data: pagePartHtml } = useLazyAsyncData(
  `page-part-${partKey}`,
  async () => {
    try {
      // Dynamically import the HTML file based on the partKey and computed localeCode
      const htmlModule = await import(
        /* webpackChunkName: "page-parts/[request]" */
        `../json/${localeCode.value}/${encodeURIComponent(partKey)}.html`
      )
      return htmlModule.default || htmlModule
    } catch (error) {
      console.error('Error loading page part:', error)
      return ''
    }
  },
)

return { __sfc: true,route, localeCode, pagePartHtml }
}

})